/**
 * Fabrica do worker de planilha — arquivo separado de proposito.
 *
 * O `new URL(..., import.meta.url)` e a sintaxe que o webpack 5 exige para
 * empacotar o worker, mas `import.meta` nao passa no transformador CommonJS
 * do Jest: qualquer arquivo de teste que importasse (mesmo indiretamente) um
 * modulo contendo essa expressao quebrava NO PARSE, antes de rodar. Isolada
 * aqui, os testes trocam a fabrica inteira por jest.mock e o Jest nunca
 * chega a ler esta linha.
 */

export function criarWorkerDePlanilha() {
  return new Worker(new URL("./planilhaParse.worker.js", import.meta.url));
}
